import { render, staticRenderFns } from "./TriviaQuizInfo.vue?vue&type=template&id=1fb5c1f6"
import script from "./TriviaQuizInfo.vue?vue&type=script&lang=js"
export * from "./TriviaQuizInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports